import { PlatformCheckboxList } from "./PlatformCheckboxList";

export default PlatformCheckboxList;
